export class QualityLevel {
    cardinality: number
    name: string
    delta: number

    constructor(q: any) {
        this.cardinality = q.cardinality
        this.name = q.name
        this.delta = q.delta

    }

    static build(q: any): QualityLevel {
        return new QualityLevel(q)
    }
}
